module.exports = __webpack_public_path__ + "static/media/id8-casa_joao.0ba73ce9.jpg";